import { DATE_TIME_FORMAT } from "constants/Define";

export function getArrDates(dates, value) {
  const startDate = dates[0];
  const endDate = dates[1];
  const result = [];

  while (startDate.isSameOrBefore(endDate, "days")) {
    result.push({
        planUseDate: startDate.format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT),
        planQty: value
    });
    startDate.add(1, "days");
  }
  return result;
}